import React from 'react';

export const Card = ({
  children,
  className = '',
  padding = 'p-6',
  shadow = 'shadow-lg',
  rounded = 'rounded-lg',
  background = 'bg-white dark:bg-gray-800'
}) => {
  return (
    <div className={`${background} ${shadow} ${rounded} ${padding} ${className}`}>
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '' }) => (
  <div className={`border-b border-gray-200 dark:border-gray-700 pb-4 mb-4 ${className}`}>{children}</div>
);

export const CardBody = ({ children, className = '' }) => (
  <div className={className}>{children}</div>
);

export const CardFooter = ({ children, className = '' }) => (
  <div className={`border-t border-gray-200 dark:border-gray-700 pt-4 mt-4 ${className}`}>{children}</div>
);
